import React, { Component } from 'react';
import './Prices.css';
import { connect } from 'react-redux';
import { Icon, Tabs, DatePicker, Input, Checkbox, Button, Notification } from 'element-react';
import { savePrice, setPrices, getPrices, setSpecialDays, deleteSpecialDay } from '../../services/rooms';

class Prices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedTab: 1,
      date: null,
      prices: [],
      months: {},
      specials: [],
      addingDay: false,
    };
  }

  async componentDidMount() {
    const prices = [];
    this.props.rooms.forEach(room => {
      prices.push({ low: room.priceLow, hight: room.priceHight });
      this.setState({ prices });
    });

    try {
      const { data } = await getPrices();
      const dates = data.specialdays.map(special => new Date(special))
      this.setState({ months: data, specials: dates });
      console.log(data.specialdays);
    } catch (err) {
      console.error(err);
    }
  }

  changePrice(key, val) {
    let price = { ...this.state.prices[this.state.selectedTab - 1] };
    price[key] = val;

    const prices = this.state.prices;
    prices[this.state.selectedTab - 1] = price;
    this.setState({ prices });
  }

  onTabClick = tab => {
    const index = parseInt(tab.props.name);
    this.setState({ selectedTab: index });
  }

  async monthChange(month, val) {
    try {
      console.log(month, val);
      await setPrices(month, val);
      console.log('ok');
    } catch (err) {
      console.error(err);
    }
  }

  savePrices = async () => {
    try {
      const prices = {
        priceHight: this.state.prices[this.state.selectedTab - 1].hight,
        priceLow: this.state.prices[this.state.selectedTab - 1].low,
      };
      await savePrice(this.props.rooms[this.state.selectedTab - 1].id, prices);
      Notification({
        title: 'Precios',
        message: 'Se han guardado correctamente',
        type: 'success'
      });
      console.log('OK');
    } catch (err) {
      console.error(err);
    }
  }

  async addSpecial() {
    if (this.state.date) {
      try {
        this.setState({ addingDay: true });
        let repeated = false;
        const specials = this.state.specials;
        specials.forEach(special => {
          if (special === this.state.date) {
            alert('Ya está en el listado de días especiales!');
            repeated = true;
          }
        })
  
        if (!repeated) {
          await setSpecialDays({ date: this.state.date.getDate(), month: this.state.date.getMonth(), year: this.state.date.getFullYear() });
          specials.push(this.state.date);
          this.setState({ specials, addingDay: false });
        } else this.setState({ addingDay: false });
      } catch (err) {
        this.setState({ addingDay: false });
        console.error(err);
        alert('Error');
      }
    }
  }

  async deleteSpecial(index) {
    try {
      const specials = this.state.specials;
      const date = this.state.specials[index];
      await deleteSpecialDay({ date: date.getDate(), month: date.getMonth(), year: date.getFullYear() });
      
      specials.splice(index, 1);
      this.setState({ specials });
    } catch (err) {
      console.error(err);
      alert('Error');
    }
  }

  render() {
    return (
      <div className="pricesViewWrapper">
        <Tabs type="card" value={this.state.selectedTab.toString()} onTabClick={this.onTabClick}>
          {
            this.props.rooms.map((room, index) => (
              <Tabs.Pane key={index} label={room.name} name={(index+1).toString()}>
                <div className="pricesContainer">

                  <div className="pricesLeftContainer">
                    <div className="priceWrapper">
                      <p>Temporada alta (€/nit): </p>
                      <Input
                        value={this.state.prices[index] && this.state.prices[index].hight}
                        type="number"
                        placeholder="Euros"
                        onChange={val => this.changePrice('hight', val)}
                      />
                    </div>
                    <div className="priceWrapper">
                      <p>Temporada baja (€/nit): </p>
                      <Input
                        value={this.state.prices[index] && this.state.prices[index].low}
                        type="number"
                        placeholder="Euros"
                        onChange={val => this.changePrice('low', val)}
                      />
                    </div>
                    <Button onClick={() => this.savePrices()}>Guardar precios</Button>
                  </div>
                </div> 
              </Tabs.Pane>
            ))
          }
        </Tabs>
        <div className="pricesRightContainer">
          <h4>Seleccionar días de temporada alta:</h4>
          <Checkbox checked={this.state.months.weekend} onChange={val => this.monthChange('weekend', val)}>Todos los fines de semana temporada alta</Checkbox>
          <div className="monthList">
            <Checkbox checked={this.state.months.enero} onChange={val => this.monthChange('enero', val)}>Enero</Checkbox>
            <Checkbox checked={this.state.months.febrero} onChange={val => this.monthChange('febrero', val)}>Febrero</Checkbox>
            <Checkbox checked={this.state.months.marzo} onChange={val => this.monthChange('marzo', val)}>Marzo</Checkbox>
            <Checkbox checked={this.state.months.abril} onChange={val => this.monthChange('abril', val)}>Abril</Checkbox>
            <Checkbox checked={this.state.months.mayo} onChange={val => this.monthChange('mayo', val)}>Mayo</Checkbox>
            <Checkbox checked={this.state.months.junio} onChange={val => this.monthChange('junio', val)}>Junio</Checkbox>
            <Checkbox checked={this.state.months.julio} onChange={val => this.monthChange('julio', val)}>Julio</Checkbox>
            <Checkbox checked={this.state.months.agosto} onChange={val => this.monthChange('agosto', val)}>Agosto</Checkbox>
            <Checkbox checked={this.state.months.septiembre} onChange={val => this.monthChange('septiembre', val)}>Septiembre</Checkbox>
            <Checkbox checked={this.state.months.octubre} onChange={val => this.monthChange('octubre', val)}>Octubre</Checkbox>
            <Checkbox checked={this.state.months.noviembre} onChange={val => this.monthChange('noviembre', val)}>Noviembre</Checkbox>
            <Checkbox checked={this.state.months.diciembre} onChange={val => this.monthChange('diciembre', val)}>Diciembre</Checkbox>
          </div>
          
          <h4>Días festivos/especiales:</h4>
          <div className="selectorDay">
            <DatePicker
              format="dd-MM-yyyy"
              firstDayOfWeek={1}
              value={this.state.date}
              placeholder="Selecciona nuevo dia festivo"
              onChange={date => this.setState({ date: date }) }
              disabledDate={time => time.getTime() < Date.now() - 8.64e7}
            />
            { this.state.addingDay
              ? <Icon name={'loading'} style={{ padding: 8 }} />
              : <Button onClick={() => this.addSpecial() }>Añadir</Button>
            }
          </div>

          <h5>Listado de días especiales:</h5>
          <div className="listDates">
            { this.state.specials.map((special, index) => <p key={index} onClick={() => this.deleteSpecial(index)}>{ `${special.getDate()}/${(special.getMonth() + 1)}/${special.getFullYear()} X `}</p>)}
          </div>
          
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({ 
  rooms: state.rooms
});

export default connect(
  mapStateToProps,
  null
)(Prices);



// WEBPACK FOOTER //
// ./src/components/Prices/Prices.js